export const INSTALL_BANNER_HEIGHT = 64;

export const quickViewHeightCorrectionStyles = {
  quickViewHeightCorrection: '--quick-view-height-correction',
  heightCorrectionWhenInstallBannerIsOpen: `${INSTALL_BANNER_HEIGHT}px`,
  heightCorrectionWhenInstallBannerIsClosed: '0px',
};
